import withSuspense from "../../../../hocs/withSuspense";
import { SettingsPageSkeleton, SettingsError } from "../../components";
import DocumentDeliveryPage from "./DocumentDeliveryPage";

export const DocumentDeliveryPageWithSuspense = withSuspense(
  DocumentDeliveryPage,
  {
    FallbackComponent: SettingsError,
    loading: (
      <SettingsPageSkeleton rows={2} testId="document-delivery-skeleton" />
    ),
  }
);
